export default "__VITE_ASSET__CCMISSKm__"